module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center top1"
  }, [_vm._v("This is a smart book which means whenever you see a QR code you can scan it with your smart phone or click on the QR code and visit the linked content. For example, scan the code below to visit the image gallery for the book or visit "), _c('a', {
    attrs: {
      "href": "http://www.borntorewild.com/gallery",
      "target": "_blank"
    }
  }, [_vm._v("www.borntorewild.com/gallery")])]), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "href": "http://www.borntorewild.com/gallery",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "center top"
  }, [_vm._v("Unauthorized reproduction of any part of this publication by any means including photocopying is an infringement of copyright. Your guarantee of quality: As publishers, we strive to produce every book to the highest commercial standards. The printing and binding have been planned to ensure a sturdy, attractive publication which should give years of enjoyment. If your copy fails to meet our high standards, please inform us and we will gladly replace it. "), _c('a', {
    attrs: {
      "href": "http://www.imagineandwonder.com",
      "target": "_blank"
    }
  }, [_vm._v("www.imagineandwonder.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center top"
  }, [_vm._v("Exclusive Distributors: APG")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v(" ISBN: 9781953652881 (Hardback)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Library of Congress Control Number: 2021933822 ")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("1st Edition")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("This book, story, and any associated content is protected. "), _c('i', [_vm._v("© ")]), _vm._v("Copyright 2021 by Manda Kalimian. Published by Imagine and Wonder Publishers, New York. 28 Sycamore Lane, Irvington New York, NY10533 United States of America. Telephone: 646.644.0403")]), _vm._v(" "), _c('p', {
    staticClass: "center top1"
  }, [_vm._v("Story by Manda Kalimian. ")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Writing by Darley Newman.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Scientific oversight and additional writing by Dr. Ross D. MacPhee Design, writing, editing, and direction by Dr. Simon E. Mills.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35356920","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/p2.vue
// module id = 60
// module chunks = 0